/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato di un requisito di configurazione del bando
 */
export enum RequisitoStato {

    OK = 'OK',

    MANCANTE = 'MANCANTE',

    NON_APPLICABILE = 'NON_APPLICABILE'
}

